import { PropsWithChildren } from 'react'
import clsx, { ClassValue } from 'clsx'

export type NavbarProps = PropsWithChildren & {
  className?: ClassValue
}

export function Navbar (props: NavbarProps) {
  return (
    <div
      className={clsx(
        'navbar',
        'min-h-12',
        'h-12',
        'sticky',
        'top-0',
        'z-40',
        'bg-white',
        'shadow-xs',
        props.className
      )}
    >
      {props.children}
    </div>
  )
}
